import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Service } from "../../../services";
import { AuthorizationRequest } from "../interfaces/flash-payment-interface";
import { EncryptWithKeyService } from "./encrypt-with-key.service";
import {environment} from "../../../../environments/environment";

const MOCK_URL = "https://13b1a259-dd75-4e77-82cf-8d7c65789d2c.mock.pstmn.io";

@Injectable({
  providedIn: "root",
})
export class FlashApiService {
  private urlService: string = "/api";

  constructor(
    private http: HttpClient,
    private services: Service,
    private encryptWithKeyService: EncryptWithKeyService
  ) {
  }

  getLocalData() {
    return this.http.get(`${environment.deploymentAssetsPath}/assets/local-data/payment-messages.json`);
  }

  newPayment(productId, offerId, paymentMode = null) {
    return this.services.newPayment(productId, offerId);
  }

  applyPayment(
    offerId,
    productId,
    paymentOptionId,
    paymentAmount,
    customerEmail,
    subscriberNumber,
    subscriberAccountNumber,
    subscriberFullName,
    subscriberAddress1,
    subscriberAddress2,
    subscriberCity,
    subscriberState,
    subscriberZipCode,
    transactionDescription,
    banSend,
    subscribeSend,
    locationId,
    invoiceNumber,
    extendedData,
    userId
  ) {
    return this.services.applyPayment(
      offerId,
      productId,
      paymentOptionId,
      paymentAmount,
      customerEmail,
      subscriberNumber,
      subscriberAccountNumber,
      subscriberFullName,
      subscriberAddress1,
      subscriberAddress2,
      subscriberCity,
      subscriberState,
      subscriberZipCode,
      transactionDescription,
      banSend,
      subscribeSend,
      locationId,
      invoiceNumber,
      userId
    );
  }

  flashPaymentLogin(key) {
    const url = `${MOCK_URL}/api/Auth/Login?key=${key}`;
    return this.http.get(url);
  }

  flashPaymentKeepAlive(token) {
    const url = `${MOCK_URL}/api/Auth/KeepAlive?token=${token}`;
    return this.http.get(url);
  }

  flashPaymentLogout(token) {
    const url = `${MOCK_URL}/api/Auth/Logout?token=${token}`;
    return this.http.get(url);
  }

  getTransactionStatus(token) {
    var form = new FormData();
    form.append("dataToken", token);
    return this.http.post(
      this.urlService + "/Authenticate/GetTransactionStatus",
      form
    );
  }

  decryptTokenByCrypto(token) {
    var form = new FormData();
    form.append("dataToken", token);
    return this.http.post(
      this.urlService + "/Authenticate/AlternativeResponse",
      form
    );
  }

  getTransactionAuthorizationEncrypt(token) {
    var form = new FormData();
    form.append("dataToken", token);
    return this.http.post<any>(
      this.urlService + "/Authenticate/getTransactionAuthorizationEncrypt",
      form
    );
  }

  tokenizeCard(token) {
    var form = new FormData();
    form.append("dataToken", token);
    let url = "/Authenticate/TokenizeCard";
    return this.http.post(this.urlService + url, form);
  }

  getTokenCards(token) {
    const form = new FormData();
    form.append("dataToken", token);
    return this.http.post(
      this.urlService + "/Authenticate/GetTokenCards",
      form
    );
  }

  deleteInstrument(token) {
    const form = new FormData();
    form.append("dataToken", token);
    return this.http.post(
      this.urlService + "/Authenticate/DeleteInstrument",
      form
    );
  }

  authorizePayment(dto) {
    const form = new FormData();
    const payload = this.encryptWithKeyService.encryp(JSON.stringify(dto));
    form.append("data", payload);
    return this.http.post(
      this.urlService + "/Authenticate/AuthorizePaymentEnc",
      form
    );
  }

  getKeys() {
    const url = this.urlService + "/Authenticate/GetKeys";
    return this.http.get(url, {headers: this.getHelpHeaders()});
  }

  getHelpHeaders(): HttpHeaders {
    let header = new HttpHeaders();
    header = header.append("authToken", "QADcsgShNdpN6M2y");
    header = header.append("appKey", "COLLECTIONPATH");
    header = header.append("content-type", "application/json; charset=utf-8");
    return header;
  }

  getPaymentsOptions() {
    const url = this.urlService + "/Authenticate/GetPaymentsOptions";
    return this.http.get(url);
  }


  downloadLastPdf(Ban, year, format, token) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("year", year);
    form.append("format", format);
    form.append("token", token);
    return this.http.post(this.urlService + '/Authenticate/DownloadLastPdf', form);
  }

  getIPAddress() {
    // return this.http.get('https://ipfind.co/me?auth=42eca74b-137e-414f-bdd3-6dfcc27d8460');
    return this.http.get("https://api.ipify.org/?format=json");
  }
}
